import { RequestQuoteInitiatedEvent } from '../../../configurator/components/RequestQuoteAction/RequestQuoteActionEvents';
import {
  ConfigurationFeatureChangedEvent,
  ConfigurationSummaryViewedEvent,
  ConfigurationViewedEvent,
} from '../../../configurator/ConfiguratorPageEvents';
import type { IBaseModel } from '../../../data/model';
import type { StoreState } from '../../../StoreState';
import { IEventAggregator } from '../../EventAggregator';
import { Analytics } from '../Analytics';

export class ConfiguratorAnalyticsListener {
  constructor(
    eventAggregator: IEventAggregator,
    private readonly getStore: () => StoreState,
  ) {
    eventAggregator.subscribe(ConfigurationViewedEvent, (e) => this.onConfigurationViewed(e));
    eventAggregator.subscribe(ConfigurationFeatureChangedEvent, (e) => this.onConfigurationFeatureChanged(e));
    eventAggregator.subscribe(ConfigurationSummaryViewedEvent, (e) => this.onConfigurationSummaryViewed(e));
    eventAggregator.subscribe(RequestQuoteInitiatedEvent, (e) => this.onRequestQuoteInitiated(e));
  }

  private onConfigurationViewed(e: ConfigurationViewedEvent) {
    Analytics.trackViewConfiguration({
      languageCode: e.shoppingContext.languageCode,
      productId: e.product.id,
      productName: e.product.name,
      canBePurchased: this.canBePurchased(e.product),
      features: e.selectedFeatures,
    });
  }

  private onConfigurationFeatureChanged(e: ConfigurationFeatureChangedEvent) {
    Analytics.trackChangeConfiguration({
      languageCode: e.shoppingContext.languageCode,
      productId: e.product.id,
      productName: e.product.name,
      canBePurchased: this.canBePurchased(e.product),
      features: e.selectedFeatures,
      targetFeature: e.selectedFeatures.find((x) => x.code === e.targetFeatureCode),
    });
  }

  private onConfigurationSummaryViewed(e: ConfigurationSummaryViewedEvent) {
    Analytics.trackViewConfigurationSummary({
      languageCode: e.shoppingContext.languageCode,
      productId: e.product.id,
      productName: e.product.name,
      canBePurchased: this.canBePurchased(e.product),
      features: e.selectedFeatures,
      configurationCode: e.configurationCode,
    });
  }

  private onRequestQuoteInitiated(e: RequestQuoteInitiatedEvent) {
    Analytics.trackActivateLead({
      currency: e.currencyCode,
      product: {
        brand: e.product.brandName,
        canBePurchased: 'canBePurchased' in e.product ? this.canBePurchased(e.product) : undefined,
        configurationCode: e.configurationCode,
        id: e.product.id,
        name: e.product.name,
        quantity: e.quantity,
      },
    });
  }

  private canBePurchased(product: IBaseModel) {
    return this.getStore().canBePurchased(product);
  }
}
